export const safeJsonStringify = <Value, DefaultValue extends string | undefined>(value: Value, defaultValue?: DefaultValue) => {
  try {
    return JSON.stringify(value)
  }
  catch (e) {
    console.error(e)
    console.error('JSON stringify error')
    return defaultValue as undefined extends DefaultValue ? undefined : string
  }
}
